export enum CertificateTypes {    
        NotSet = 0,    
        Part91 = 91,    
        Part121 = 121,    
        Part135 = 135
}
